import http from '@/requests/http'
import utilityHelper from '@/helpers/utils'

class TimeCondition {
  static findAll (params) {
    return http.post('time-conditions/index', params)
  }
  static store (params) {
    return http.post('time-conditions/store', params)
  }
  static view (params) {
    return http.post('time-conditions/view', params)
  }
  static update (params) {
    return http.post('time-conditions/update', params)
  }
  static destroy (params) {
    return http.post('time-conditions/destroy', params)
  }
  static async storeSoundFile (data) {
    const formData = new FormData()
    await utilityHelper.buildFormData(formData, data)
    return http.post('time-conditions/sound-file/store', formData, {
      headers: {
        'Content-Type': 'multipart/form-data'
      }
    })
  }
  static destroySoundFile (params) {
    return http.post('time-conditions/sound-file/destroy', params)
  }
  static apply (params) {
    return http.post('time-conditions/apply-config', params)
  }
}

export default TimeCondition
